import { render, staticRenderFns } from "./tab_pemberitahuan_integrasi.vue?vue&type=template&id=2f92e1c4&"
import script from "./tab_pemberitahuan_integrasi.vue?vue&type=script&lang=js&"
export * from "./tab_pemberitahuan_integrasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports